import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .main-div {
    height: 100%;
    width: 100%;
    overflow-y: auto;
    background: radial-gradient(
      ellipse farthest-corner at 50% 100%,
      ${colors.background.normal} 20%,
      ${colors.background.dark} 90%
    );
  }

  .noscript-div {
    display: inline;
  }

  .noscript-img {
    border-style: none;
  }

  .btn-back {
    margin-right: 0px !important;
    border: none !important;
  }

  .btn-back-icon {
    padding-top: 6px;
    padding-right: 15px;
    color: #000;
    vertical-align: middle;
    height: 24px;
    width: 24px;
  }

  .btn-submit {
    margin-top: 15px !important;
    margin-bottom: 7px !important;
  }

  .support-contact {
    font-weight: 300;
    font-size: 15px;
    color: #fff;
  }

  .support-contact-email {
    font-weight: 900;
    color: #fff;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/sign-up/style.js